import Vue from "vue";
import App from "./App.vue";

// Sentry Log Monitor
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if (process.env.NODE_ENV === "production") {
  console.log("Sentry iniciado...");

  Sentry.init({
    dsn: 'https://e688a2dd60b849b8986ddf2e7e3e4823@sentry.io/1838072',
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
        logErrors: true
      })
    ],
  });
}

// registra os plugins
import plugins from '@/plugins';
Vue.prototype.$plugins = plugins;

// Qr Code
import VueQrcode from '@chenfengyuan/vue-qrcode';
Vue.component(VueQrcode.name, VueQrcode);

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// WhiteLabel Configs
import whitelabel from "@/whitelabel";
Vue.prototype.$whitelabel = whitelabel;

// Theme Configurations
Vue.use(Vuesax, {
  theme: {
    colors: whitelabel.colors
  }
});

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/index";

// Clipboard
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// Vuesax Admin Filters
import "./filters/filters";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// VeeValidate
import VeeValidate, { Validator } from "vee-validate";
import { CustomValidator } from "./plugins/validation";
Validator.extend("cpf", CustomValidator.CpfValidator);
Validator.extend("telefone", CustomValidator.TelefoneValidator);
Validator.extend("option", CustomValidator.OptionValidator);
Vue.use(VeeValidate, { locale: "pt", dictionary: CustomValidator.Dictionary });

// Global
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

// Date Range Picker
import DateRangePicker from "@gravitano/vue-date-range-picker";
Vue.use(DateRangePicker);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

// Font Cerebri
require("./assets/css/font-cerebri.css");

// Pusher
require("pusher-js");
import Echo from "laravel-echo";
Vue.prototype.$socket = new Echo({
  broadcaster: "pusher",
  key: "6ea3e3570aa091397ca0",
  cluster: "us3",
  forceTLS: true
});

// axios
import axios from "axios";
Vue.prototype.$http = axios;

// This is a global mixin, it is applied to every vue instance
import mixin from "@services/mixin-service";
Vue.mixin(mixin);

Vue.config.productionTip = false;

// Registra as directivas
require("@/directives")

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
